import PromoList from './PromoList';
import PromoCreate from './PromoCreate'
import PromoEdit from  './PromoEdit'

export default {
    list:PromoList,
    create:PromoCreate,
    edit:PromoEdit
};